import React, {useContext, createContext, useState} from 'react';
import jamaicaIcon from "../assets/jamaica_icon.svg";

const CountryContextValue = createContext(undefined, undefined);

export function useCountryContextContext() {
    return useContext(CountryContextValue);
}

export function CountryContext({children}) {
    const [country, setCountry] = useState({
        label: <img src={jamaicaIcon} height="30px" width="30px" alt=""/>,
        value: "jamaica"
    });

    return (
        <CountryContextValue.Provider
            value={{country, setCountry}}
        >
            {children}
        </CountryContextValue.Provider>
    );
}

